(() => {
  angular
    .module('app.campaign')
    .controller('CampaignDetailsController', CampaignDetails);

  CampaignDetails.$inject = [
    '$scope',
    '$location',
    'ModalService',
    'EventsService',
    'AccountLabelsData',
    'SupportedCountriesData',
    'CampaignManagerService',
  ];

  function CampaignDetails(
    $scope,
    $location,
    ModalService,
    EventsService,
    AccountLabelsData,
    SupportedCountriesData,
    CampaignManagerService,
  ) {
    const vm = this;
    const allAccountLabels = AccountLabelsData.data;

    vm.isIRBetaOn = $('#current-user').data('feature-irbeta') === 1;
    vm.campaign = CampaignManagerService.getCampaignData();

    vm.isEdit = () => $location.path().split('/')[1] === 'edit';

    vm.types = [{
      value: 'standard',
      name: 'Standard Campaign',
      description: `AudienceReport as you know it with support for advanced features
        like custom segments, multiple event type and more.`,
    }, {
      value: 'integrated',
      name: 'Integrated Report',
      description: `A simplified report format where you can combine standard AudienceReport
        campaigns with sources like Facebook and YouTube.`,
    }];

    vm.supportedCountries = SupportedCountriesData.data;

    vm.selectCountry = function (countryIsoCode) {
      vm.campaign.panel_country = countryIsoCode;
    };

    vm.selectType = function (type) {
      vm.campaign.type = type;
      vm.initEventTypes();
    };

    vm.getType = function () {
      const type = vm.types.find(item => item.value === vm.campaign.type);
      return type && type.name;
    };

    vm.getCountry = function () {
      if (vm.supportedCountries) {
        const country = vm.supportedCountries.find(item => item.isoCode === vm.campaign.panel_country);
        return country && country.name;
      }

      return vm.campaign.panel_country;
    };

    vm.isCalculationMethodSelected = () => {
      if (!vm.campaign.sources) {
        return false;
      }

      const source = vm.campaign.sources.find(item => item.platform === 'dv360');
      if (!source) {
        return false;
      }

      return source.meta && source.meta['dv360_rtbv_as_trueview'];
    };



    /* ************************************************************* */
    /* ************************* Event types *********************** */
    /* ************************************************************* */
    const eventTypes = EventsService.getAllowedEventTypes();

    const getCampaignEventTypes = () => {
      if (!vm.campaign) {
        return [];
      }

      return Object.keys(
        vm.campaign.trackpoints
          .reduce((memo, item) => ({
            ...memo,
            ...item.eventTypes,
          }), {})
        ).map(item => eventTypes.find(({ type}) => type === item));
    };

    const defaultEventType = [{
      type: 'auto',
      cssClass: 'automatic',
      labelName: 'Auto determine (default)',
    }];

    vm.availabelEventTypes = () => {
      if (vm.campaign.type === 'integrated') {
        const typesIntegrated = [
          'impression',
          'videostart',
          'video25pct',
          'video50pct',
          'video75pct',
          'videocomplete',
        ];

        const integratedEventTypes = eventTypes.filter(({ type }) => typesIntegrated.includes(type));

        return defaultEventType.concat(integratedEventTypes);
      }

      return defaultEventType.concat(getCampaignEventTypes());
    };

    const getEvetItem = eventType => eventType ?
      vm.availabelEventTypes().find(({ type }) => type === eventType) :
      vm.availabelEventTypes()[0];

    vm.onSelectEventType = event => {
      vm.selectedEventType = getEvetItem(event.type);
      vm.campaign.reachBuildingEventType = vm.selectedEventType.type;
    };

    vm.initEventTypes = () => {
      vm.selectedEventType = getEvetItem(vm.campaign?.reachBuildingEventType);
    };

    vm.initEventTypes();



     /* ************************************************************* */
     /* ********** Label modal to edit labels for campaigns ********* */
     /* ************************************************************* */
    vm.openLabelModal = function () {
      ModalService
        .showModal({
          templateUrl: '../../assets/js/app/campaign/modals/labels.html',
          controller: 'LabelsModalController',
          controllerAs: 'labelModal',
          inputs: {
            checkedCampaigns: [vm.campaign],
            allLabelNames: allAccountLabels,
            persistChanges: false
          }
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(result => {});
        });
    };

    /* Persist changes to service */
    $scope.$watch(() => vm.campaign,
      campaign => {
        CampaignManagerService.setCampaignData(campaign);

        if (CampaignManagerService.isCampaignFieldChanged('panel_country')) {
          CampaignManagerService.showTechedgeNotification(campaign);
        }
      }, true);
  }
})();
